export default "__VITE_ASSET__Dzkr5NG0__"